import type * as React from "react";
import type { useRouter } from "@tanstack/react-router";

import { AuthContext, useAuthContext } from "./hooks";

export function AuthProvider({
	children,
	router,
}: {
	children: React.ReactNode;
	router: ReturnType<typeof useRouter>;
}) {
	return (
		<AuthContext value={useAuthContext({ router })}>{children}</AuthContext>
	);
}
